"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var Card_1 = __importDefault(require("./Card"));
exports.Card = Card_1.default;
exports.default = Card_1.default;
//# sourceMappingURL=index.js.map